var _path, _g, _g2, _g3, _path2, _path3, _circle, _path4, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawDoctorsDjoj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 692.68042,
    height: 596.95062,
    viewBox: "0 0 692.68042 596.95062",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0,590.90472c0,.8714.69976,1.57111,1.57114,1.57111h689.53823c.87134,0,1.57104-.69971,1.57104-1.57111,0-.87134-.69977-1.57111-1.57104-1.57111H1.57114c-.87139,0-1.57114.69977-1.57114,1.57111Z",
    fill: "#3f3c57"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "224.97621 63.44081 232.47475 97.65798 216.52524 145.28497 190.8288 94.11363 194.39423 64.42697 224.97621 63.44081",
    fill: "#fdb4b4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.49968,
    y: 95.88581,
    width: 44.36823,
    height: 53.60809,
    fill: "#F2FAFE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.62289,
    cy: 50.37625,
    r: 30.30031,
    fill: "#fdb4b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.24777,72.90763s-22.58591-41.71245-2.22203-61.78555c20.36388-20.0731,36.71103-6.84618,36.71103-6.84618l9.33479-.37726s1.94691,7.34635,5.0862,3.36946,8.81216,10.50643,8.81216,10.50643c10.52892,18.96209-25.97099,23.20996-25.97099,23.20996,0,0,2.63567,8.3958-.04329,10.15408s-9.83669,8.37259-9.83669,8.37259l-6.40665,4.83868-3.8073-5.80089s-3.97688-3.1393-5.98611-1.82059.75452,18.66962.75452,18.66962l-6.42567-2.49033.00002-.00002s.00002,0,.00002,0Z",
    fill: "#2e2e41"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.89828 379.77917 141.31369 552.58276 169.7925 553.54815 207.44244 381.22726 152.89828 379.77917",
    fill: "#2e2e41"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.92319 378.81381 210.33859 551.61743 238.8174 552.58276 276.46735 380.26187 221.92319 378.81381",
    fill: "#2e2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.92245,419.25979l15.16064-188.20752-23.24951-98.00391c-2.00439-14.56836,7.1748-28.35303,21.3418-32.11182l22.75-6.03564,10.06934-10.06982,22.90332,50.57812,14.3042-50.53955,11.15576,8.11328,33.08643,14.59717-.01514.3418-5.30713,118.38818,11.84668,191.27394-.52539.00684-133.521,1.66895v-.00003Z",
    fill: "#e8e9ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.98882,550.61914l8.24609,24.61713s32.26085,4.38617,32.7628,14.37354-43.84415,4.20612-69.81137,5.51123-4.35153-26.81537-4.35153-26.81537l2.76715-16.15924,30.38686-1.52722h0v-.00006Z",
    fill: "#2e2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.64642,548.84698l8.24609,24.61713s32.26083,4.38617,32.76282,14.37354-43.84415,4.20612-69.81137,5.51123-4.35153-26.81543-4.35153-26.81543l2.76715-16.15924,30.38686-1.52722h-.00002Z",
    fill: "#2e2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-2a99fb06-c611-4846-a9cf-67468c4aeefc-1519",
    d: "m129.41473,319.30487c-.3497-4.85364.46838-9.72049,2.38571-14.19315l-6.15435-50.48595,24.1083-2.22585,3.64648,51.45175c2.42278,4.21848,3.80009,8.95581,4.01672,13.81573.70905,12.15649-4.98497,22.37265-12.71864,22.82397s-14.57712-9.03418-15.28426-21.18646h.00005l-.00003-.00003.00002-.00003Z",
    fill: "#fdb4b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-a83e19fb-8297-4073-aac4-48fd1880d45d-1520",
    d: "m282.1105,326.71539c-.29675-4.85718.57434-9.71481,2.54031-14.16629l-5.60358-50.55005,24.13113-1.96289,3.08533,51.48843c2.37665,4.24463,3.70224,8.9967,3.86588,13.8587.57648,12.16351-5.22858,22.31696-12.96671,22.68396s-14.47775-9.19257-15.05237-21.35181h.00003l-.00003-.00003v-.00003Z",
    fill: "#fdb4b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.54696,299.05813l-.08154-.43555-12.56445-67.41455,14.84619-109.77734c1.32471-9.80078,10.07616-16.86084,19.94482-16.07178,5.15381.4126,9.77783,2.85693,13.02148,6.88379,3.24316,4.02686,4.64648,9.06592,3.95117,14.18945l-11.17383,82.33154,7.03516,88.06152s-34.979,2.23291-34.979,2.23291Z",
    fill: "#e8e9ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.66464,297.4761l-25.26123-168.62109c-1.31299-4.94434-.54443-10.11865,2.17529-14.51562s7.00586-7.39502,12.06934-8.44238c9.68701-2.00342,19.25244,3.91797,21.78076,13.47852l24.26807,175.98293-35.03223,2.11768v-.00003Z",
    fill: "#e8e9ea"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.63914,
    cy: 147.72172,
    r: 3.10129,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.63914,
    cy: 171.20295,
    r: 3.10129,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.63914,
    cy: 194.68417,
    r: 3.10129,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.63914,
    cy: 218.1654,
    r: 3.10129,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.63914,
    cy: 241.64662,
    r: 3.10129,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.63914,
    cy: 265.12783,
    r: 3.10129,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.63914,
    cy: 288.60906,
    r: 3.10129,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.63914,
    cy: 312.0903,
    r: 3.10129,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.64284 333.35574 156.96283 325.53573 155.83282 325.38571 125.84284 256.23568 107.98279 215.0657 154.50281 215.0657 215.64284 333.35574",
    fill: "#F2FAFE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "450.9183 70.96385 488.22565 50.52592 488.22565 108.91998 445.07889 108.91998 450.9183 70.96385",
    fill: "#2e2e41"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "496.2244 83.98281 499.66748 112.65083 474.85278 162.06628 459.45056 116.07353 466.6918 83.0305 496.2244 83.98281",
    fill: "#fdb4b4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.10519,
    y: 114.36218,
    width: 42.84579,
    height: 51.76859,
    fill: "#F2FAFE"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "536.29645 388.51412 547.48352 555.38818 519.98193 556.32043 483.62393 389.9125 536.29645 388.51412",
    fill: "#2e2e41"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "469.64005 387.58184 480.82715 554.45593 453.32556 555.38818 416.9675 388.98025 469.64005 387.58184",
    fill: "#2e2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m565.35211,423.90725l-.65527-.00195-175.19824-.57227.15723-.62012,45.04297-178.46143-11.2832-90.06299c-2.1377-17.06592,6.99805-33.19678,22.7334-40.13867l5.68066-2.50586,10.79199-7.84814,13.80566,48.78368,22.1084-48.82178,9.73926,9.73779,21.96387,5.82764c13.69043,3.63184,22.55957,16.95166,20.63086,30.98291l-.02344.09766-33.54199,95.70947,48.04785,177.89404Z",
    fill: "#e8e9ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.0914,553.49188l29.34415,1.47485,2.67218,15.6048s20.87399,27.15558-4.20221,25.89526-67.90063,4.32257-67.41586-5.32214,31.63858-13.88031,31.63858-13.88031l7.96313-23.7724h0l.00003-.00006Z",
    fill: "#2e2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m520.12299,551.78057l29.34418,1.47485,2.67218,15.6048s20.87396,27.15558-4.20221,25.89526-67.90063,4.32257-67.41586-5.32214,31.63858-13.88031,31.63858-13.88031l7.96313-23.7724h0v-.00006Z",
    fill: "#2e2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-3bc2e7c3-8a4e-432b-b93d-ff096d796d3b-1521",
    d: "m546.99469,328.40359h.00006c-.68286,11.73526-7.2915,20.89529-14.75983,20.45947-7.46832-.43585-12.96692-10.30145-12.28223-22.0408.20923-4.69315,1.53925-9.26794,3.87891-13.34164l3.52136-49.68625,23.28107,2.14948-5.94318,48.7536c1.85156,4.31918,2.64154,9.01901,2.30383,13.70612v.00003Z",
    fill: "#fdb4b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-a34cbb18-fa14-4c0b-8260-87fab6b8d9f9-1522",
    d: "m427.35587,323.94125h.00003c-.93253,11.71808-7.73462,20.73538-15.19196,20.14066s-12.74472-10.57513-11.81027-22.29724c.30905-4.68762,1.73618-9.23306,4.16202-13.25607l4.57819-49.60001,23.23004,2.64456-6.97961,48.61603c1.75919,4.3576,2.44897,9.07321,2.01157,13.75204l-.00003.00003h.00003Z",
    fill: "#fdb4b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m550.74371,308.86965l-33.81152-2.1582.04102-.50684,6.75391-84.54883-10.78906-79.50439c-.67285-4.95215.68359-9.82324,3.81836-13.71533,3.13477-3.89258,7.60449-6.25537,12.58691-6.6543h0c9.53906-.75195,17.99707,6.06201,19.27832,15.53516l14.33691,106.01318-.01465.0791-12.2002,65.46045Z",
    fill: "#e8e9ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.98495,305.63088l-33.86523-2.04736.07422-.53467,23.35254-169.37012c2.45605-9.30225,11.70605-15.02393,21.06543-13.08838,4.89453,1.01221,9.03711,3.91016,11.66602,8.16064s3.37207,9.25146,2.0918,14.08252l-24.38477,162.79736Z",
    fill: "#e8e9ea"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.70847,
    cy: 164.4194,
    r: 2.99487,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.70847,
    cy: 187.09492,
    r: 2.99487,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.70847,
    cy: 209.77041,
    r: 2.99487,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.70847,
    cy: 232.4459,
    r: 2.99487,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.70847,
    cy: 255.12141,
    r: 2.99488,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.70847,
    cy: 277.7969,
    r: 2.99487,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.70847,
    cy: 300.47241,
    r: 2.99487,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.70847,
    cy: 323.14788,
    r: 2.99487,
    fill: "#d6d7d8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.25485,
    cy: 70.60121,
    r: 28.0126,
    fill: "#fdb4b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m494.93509,37.9c1.34232,2.73002-.78644,6.14016-3.60379,7.28794s-5.99994.68273-9.00439.20496-6.19162-.93081-9.00061.23728c-3.63461,1.5114-5.68341,5.30272-7.44885,8.82095-3.29578,6.56796-6.59155,13.13592-9.88733,19.70388-1.61026,3.20898-3.25699,6.56223-3.28802,10.15242-.05695,6.59007,5.1709,11.85661,7.98364,17.81652,3.42468,7.25651,3.1423,16.14937-.7359,23.17396-3.8782,7.0246-11.25323,12.00169-19.21866,12.96986-2.09576.25471-4.31387.22707-6.19815-.72504s-3.32245-3.03139-2.97348-5.11353c.6825-4.07246,6.9053-5.02404,8.04816-8.99201.59659-2.07135-.45999-4.28337-1.8844-5.90124s-3.22565-2.87991-4.58432-4.55338c-3.13287-3.85881-3.34158-9.81566-.48651-13.88428,1.67792-2.39111,4.2731-4.1676,5.35754-6.87995.92432-2.31188.58865-4.91064.23856-7.37572-.44983-3.16758-.89969-6.33516-1.34949-9.50274-.52481-3.69564-1.04166-7.52378-.00443-11.1095,2.37692-8.21708,11.65509-12.07628,17.09622-18.67659,2.52844-3.06711,4.22925-6.75578,6.82321-9.76769,4.353-5.0544,11.20612-7.84266,17.85138-7.26305,6.64526.57962,12.91214,4.51224,16.32437,10.24394",
    fill: "#2e2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m490.51276,38.41812c-1.36856.48943-1.8764,2.27196-1.48245,3.67102.39392,1.39905,1.42548,2.51068,2.36969,3.61567,10.67899,12.4976,13.16113,31.40143,6.07047,46.23225-1.88605,3.94485-4.39844,7.65742-5.41574,11.90996-.7402,3.09426-.70041,6.48836-2.41699,9.1671-1.74765,2.7272-5.21078,4.55455-5.55328,7.77551-.21979,2.06699,1.04007,4.07476,2.72891,5.2866s3.75204,1.76633,5.78091,2.21844c5.27338,1.17508,10.6655,1.8166,16.06738,1.91158,1.76111.03098,3.5784-.00714,5.19394-.70886s2.99451-2.22359,3.01294-3.98486c.01447-1.38427-.78387-2.66127-.88574-4.04187-.30518-4.13684,5.26141-6.33762,6.34595-10.34142.71301-2.63228-.69177-5.34093-2.18835-7.62076-1.49652-2.27983-3.20422-4.6738-3.16742-7.4007.03528-2.61049,1.67352-4.90948,2.31024-7.44138.88068-3.50216-.20117-7.16535-1.27429-10.61342-.91235-2.93147-1.82465-5.86292-2.737-8.79439-.96985-3.11624-1.93964-6.23248-2.90948-9.34872-1.69315-5.44035-3.47049-11.0383-7.13446-15.40172-3.664-4.36341-9.73514-7.22331-15.14719-5.44181",
    fill: "#2e2e41"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m509.60117,146.96731l-1.91992-.55957c4-13.71533-4.625-39.31006-4.71191-39.56689l1.89258-.64551c.36621,1.07373,8.91507,26.45605,4.73926,40.77197Z",
    fill: "#3f3c57"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 508.64127,
    cy: 154.36679,
    r: 8.3541,
    fill: "#3f3c57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.7496,183.9429h-5.06641c-.55273,0-1-.44775-1-1s.44727-1,1-1h5.06641c1.39648,0,2.70801-.54395,3.69434-1.53223.98535-.98779,1.52734-2.30078,1.52441-3.69629l-.06152-31.20654c0-6.7793-5.51367-12.29297-12.29102-12.29297s-12.29199,5.51367-12.29199,12.29102l.06152,29.20947c.00586,2.84961,2.3291,5.18555,5.17871,5.20752l3.47754.02637c.55176.00439.99609.45508.99219,1.00781-.00391.54932-.45117.99219-1,.99219h-.00781l-3.47754-.02637c-3.94141-.03027-7.15527-3.26221-7.16309-7.20361l-.06152-29.21143c0-7.88184,6.41113-14.29297,14.29199-14.29297,7.87988,0,14.29102,6.41113,14.29102,14.29102l.06152,31.20459c.00391,1.93066-.74512,3.74658-2.10938,5.11279-1.36328,1.3667-3.17871,2.11963-5.10938,2.11963Z",
    fill: "#3f3c57"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 443.03412,
    cy: 180.94929,
    r: 3.54434,
    fill: "#3f3c57"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 448.68292,
    cy: 182.94299,
    r: 3.54434,
    fill: "#3f3c57"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m244.07133,131.97773l-1.91992-.55957c4-13.71533-4.52802-39.70649-4.61493-39.96333l2.39981,1.80909c.36621,1.07373,8.31082,24.39789,4.13504,38.71381Z",
    fill: "#3f3c57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m176.58131,134.41444l1.91992-.55957c-4-13.71533,4.625-39.31006,4.71191-39.56689l-2.05376,1.37573c-.36621,1.07373-8.75386,24.43481-4.57808,38.75073Z",
    fill: "#3f3c57"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 243.11143,
    cy: 139.37721,
    r: 8.35408,
    fill: "#3f3c57"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m185.48769,185.78889h-5.06641c-.55273,0-1-.44775-1-1s.44727-1,1-1h5.06641c1.39648,0,2.70801-.54395,3.69434-1.53223.98535-.98779,1.52734-2.30078,1.52441-3.69629l-.06152-31.20654c0-6.7793-5.51367-12.29297-12.29102-12.29297s-12.29199,5.51367-12.29199,12.29102l.06152,29.20947c.00586,2.84961,2.3291,5.18555,5.17871,5.20752l3.47754.02637c.55176.00439.99609.45508.99219,1.00781-.00391.54932-.45117.99219-1,.99219h-.00781l-3.47754-.02637c-3.94141-.03027-7.15527-3.26221-7.16309-7.20361l-.06152-29.21143c0-7.88184,6.41113-14.29297,14.29199-14.29297,7.87988,0,14.29102,6.41113,14.29102,14.29102l.06152,31.20459c.00391,1.93066-.74512,3.74658-2.10938,5.11279-1.36328,1.3667-3.17871,2.11963-5.10938,2.11963Z",
    fill: "#3f3c57"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.7722,
    cy: 182.7953,
    r: 3.54434,
    fill: "#3f3c57"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.42099,
    cy: 184.78901,
    r: 3.54434,
    fill: "#3f3c57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawDoctorsDjoj);
export default __webpack_public_path__ + "static/media/undraw_doctors_djoj.95dbac6df36ff6f32821a13e8cae0b72.svg";
export { ForwardRef as ReactComponent };